// extracted by mini-css-extract-plugin
module.exports = {"Cookies__wrapper":"ahrr","Cookies__root":"tJmp","Cookies__inner_float":"BkAf","Cookies__inner":"AxB_"};